import type { CallbackRequest } from '@pole-api/lib-ifa-communication-api/lib/models/CallbackRequest'
import type { IFinancingCallbackForm } from './types'

export const getRequestBodyForCallbackRequest = (formValue: IFinancingCallbackForm, contextOfRequest: string): CallbackRequest => {
  return { ...formValue, comment: contextOfRequest }
}
